import '@babel/polyfill';
// eslint-disable-next-line
import { h, render } from 'preact';
import Root from './root';
import { APP_CONTAINER_ID } from './consts';

document.addEventListener('DOMContentLoaded', () => {
    let appContainer = document.querySelector(`#${APP_CONTAINER_ID}`);
    if (appContainer) {
        console.warn('USC element already exists on the page.');
        return;
    }
    appContainer = document.createElement('div');
    appContainer.id = APP_CONTAINER_ID;
    document.body.appendChild(appContainer);

    // update viewport meta to support phones with edge-to-edge screens
    const metaEls = Array.prototype.slice.apply(document.querySelectorAll('meta[name="viewport"]'));
    metaEls.forEach(elMetaViewport => {
        if (!elMetaViewport.content.includes('viewport-fit')) {
            elMetaViewport.setAttribute('content', `${elMetaViewport.content},viewport-fit=cover`);
        }
    });

    render(<Root />, appContainer);
});
